export class UserObject {
	id: string;
	firstname: string;
	lastname: string;
	login: string;
	email: string;
	array_options: {
		options_pole: string,
		options_pole_label: string;
		options_pole_ref: string;
		options_polem: string
		options_lundi_am_debut: string;
		options_lundi_am_fin: string;
		options_lundi_matin_debut: string;
		options_lundi_matin_fin: string;
		options_mardi_am_debut: string;
		options_mardi_am_fin: string;
		options_mardi_matin_debut: string;
		options_mardi_matin_fin: string;
		options_mercredi_am_debut: string;
		options_mercredi_am_fin: string;
		options_mercredi_matin_debut: string;
		options_mercredi_matin_fin: string;
		options_jeudi_am_debut: string;
		options_jeudi_am_fin: string;
		options_jeudi_matin_debut: string;
		options_jeudi_matin_fin: string;
		options_vendredi_am_debut: string;
		options_vendredi_am_fin: string;
		options_vendredi_matin_debut: string;
		options_vendredi_matin_fin: string;
	};
	rights: any;
	groups: any;
	admin: any;

	full_name: string;

	pole: string;
	pole_id: string;
	pole_m: string[];
	group: string;
	isAdmin: boolean;

	constructor(id = null, firstname = null, lastname = null, login = null, email = null, array_options = null, rights = null, groups = null, admin = null) {
		this.id = id;
		this.firstname = firstname;
		this.lastname = lastname;
		this.login = login;
		this.email = email;
		this.array_options = array_options;
		this.rights = rights;
		this.groups = groups;
		this.admin = admin;

		this.full_name = (firstname ? firstname : '') + ' ' + (lastname ? lastname : '');
		this.pole = array_options?.options_pole_label || '(Autre)';
		this.pole_id = array_options?.options_pole_ref;
		this.pole_m = this.getPolesRefFromIds(array_options?.options_polem?.split(',') ?? []);
		this.group = groups?.length > 0 ? groups[0].name : null;
		this.isAdmin = admin == 1;
	}

	public static LoadFromJSON(json: any) {
		return new UserObject(
			json['id'],
			json['firstname'],
			json['lastname'],
			json['login'],
			json['email'],
			json['array_options'],
			json['rights'],
			json['groups'],
			json['admin']
		);
	}

	private getPolesRefFromIds(ids: string[]) {
		const poles = [
			{id: '2', ref: 'admin'},
			{id: '6', ref: 'bati'},
			{id: '7', ref: 'supp'},
			{id: '8', ref: 'urba'},
			{id: '9', ref: 'eau'},
			{id: '10', ref: 'voi'}
		];

		return ids.map(id => {
			const pole = poles.find(pole => pole.id === id);
			return pole ? pole.ref : 'autre';
		});
	}

	isAuthorized(page, action, status?, data?) {

		if (this.isAdmin) {
			return true;
		}
		if ('Lecteur' === this.group) {
			return false;
		}

		// Groups

		// Direction
		// Assistante de direction
		// Administratif
		// Responsable de pôle
		// Agent
		// Lecteur

		switch (page) {
			case 'Conventions':
				switch (action) {
					case 'Envoyer':
						switch (status) {
							case 'valide':
								return true;
							default:
								return false;
						}
					case 'ExporterExcel':
					case 'ExporterPdf':
					case 'VoirPdf':
					case 'Dupliquer':
						return true;
					default :
						return false;
				}
			case 'Convention':
				switch (action) {
					case 'Ajouter':
						return true;
					case 'Modifier':
						return true;
					case 'ChangerStatus':
						switch (status) {
							case 'valide':
								switch (this.group) {
									case 'Direction':
										return true;
									default:
										return false;
								}
							case 'soldee':
								switch (this.group) {
									case 'Direction':
										return true;
									default:
										return false;
								}
							default:
								return true;
						}
					case 'VisualiserValiderFacture':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'ValiderFacture':
						switch (this.group) {
							case 'Direction':
								return true;
							default:
								return false;
						}
					case 'VisualiserAValiderFacture':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'AValiderFacture':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'Supprimer':
						switch (this.group) {
							case 'Direction':
								return true;
							default:
								return false;
						}
					default :
						return false;
				}
			case 'ConventionSuiviActivite':
				switch (action) {
					case 'Modifier':
						return data === this.id;
					default :
						return false;
				}
			case 'CertificatPaiement':
				switch (action) {
					case 'Modifier':
						return true;
					case 'Supprimer':
						return true;
					default :
						return false;
				}
			case 'FeuilleHeures':
				switch (action) {
					case 'Ajouter':
						return true;
					case 'Supprimer':
						return true;
					case 'Modifier':
						return true;
					default :
						return false;
				}
			case 'Marches':
				switch (action) {
					case 'Ajouter':
						return true;
					default :
						return false;
				}
			case 'Marche':
				switch (action) {
					case 'Modifier':
						return true;
					case 'Supprimer':
						return true;
					default :
						return false;
				}
			case 'Adherents':
				switch (action) {
					case 'Ajouter':
						return true;
					default :
						return false;
				}
			case 'Fournisseurs':
				switch (action) {
					case 'Ajouter':
						return true;
					default :
						return false;
				}
			case 'Utilisateurs':
				switch (action) {
					case 'Ajouter':
						return true;
					default :
						return false;
				}
			case 'Articles':
				switch (action) {
					case 'Ajouter':
						return true;
					default :
						return false;
				}
			case 'Parametres':
				switch (action) {
					case 'Voir':
						return true;
					default :
						return false;
				}
			case 'Planning':
				switch (action) {
					case 'ListeAllUsers':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'Ajouter':
						return true;
					case 'Modifier':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							case 'Assistante de direction':
							case 'Administratif':
							case 'Agent':
								return this.id === data;
							default:
								return false;
						}
					case 'AjouterAbsence':
					case 'ModifierAbsence':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
							case 'Assistante de direction':
								return true;
							default:
								return false;
						}
					default :
						return false;
				}
			case 'Indicateurs':
				switch (action) {
					case 'Visualiser':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'VisualiserAllPoles':
						switch (this.group) {
							case 'Direction':
								return true;
							default:
								return false;
						}
					case 'VisualiserSuiviAdherents':
						switch (this.group) {
							case 'Direction':
								return true;
							default:
								return false;
						}
					case 'VisualiserSuiviConventions':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'VisualiserSuiviChiffreAffaires':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'VisualiserSuiviFacturation':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					case 'VisualiserSuiviReste':
						switch (this.group) {
							case 'Direction':
							case 'Responsable de pôle':
								return true;
							default:
								return false;
						}
					default :
						return false;
				}
			default:
				return false;
		}
	}

	getWorkingHours() {
		const workingHours = [];
		if (this.array_options?.options_lundi_matin_debut && this.array_options?.options_lundi_matin_fin) {
			workingHours.push({
				startTime: this.array_options.options_lundi_matin_debut,
				endTime: this.array_options.options_lundi_matin_fin,
				daysOfWeek: [1]
			});
		}
		if (this.array_options?.options_lundi_am_debut && this.array_options?.options_lundi_am_fin) {
			workingHours.push({
				startTime: this.array_options.options_lundi_am_debut,
				endTime: this.array_options.options_lundi_am_fin,
				daysOfWeek: [1]
			});
		}
		if (this.array_options?.options_mardi_matin_debut && this.array_options?.options_mardi_matin_fin) {
			workingHours.push({
				startTime: this.array_options.options_mardi_matin_debut,
				endTime: this.array_options.options_mardi_matin_fin,
				daysOfWeek: [2]
			});
		}
		if (this.array_options?.options_mardi_am_debut && this.array_options?.options_mardi_am_fin) {
			workingHours.push({
				startTime: this.array_options.options_mardi_am_debut,
				endTime: this.array_options.options_mardi_am_fin,
				daysOfWeek: [2]
			});
		}
		if (this.array_options?.options_mercredi_matin_debut && this.array_options?.options_mercredi_matin_fin) {
			workingHours.push({
				startTime: this.array_options.options_mercredi_matin_debut,
				endTime: this.array_options.options_mercredi_matin_fin,
				daysOfWeek: [3]
			});
		}
		if (this.array_options?.options_mercredi_am_debut && this.array_options?.options_mercredi_am_fin) {
			workingHours.push({
				startTime: this.array_options.options_mercredi_am_debut,
				endTime: this.array_options.options_mercredi_am_fin,
				daysOfWeek: [3]
			});
		}
		if (this.array_options?.options_jeudi_matin_debut && this.array_options?.options_jeudi_matin_fin) {
			workingHours.push({
				startTime: this.array_options.options_jeudi_matin_debut,
				endTime: this.array_options.options_jeudi_matin_fin,
				daysOfWeek: [4]
			});
		}
		if (this.array_options?.options_jeudi_am_debut && this.array_options?.options_jeudi_am_fin) {
			workingHours.push({
				startTime: this.array_options.options_jeudi_am_debut,
				endTime: this.array_options.options_jeudi_am_fin,
				daysOfWeek: [4]
			});
		}
		if (this.array_options?.options_vendredi_matin_debut && this.array_options?.options_vendredi_matin_fin) {
			workingHours.push({
				startTime: this.array_options.options_vendredi_matin_debut,
				endTime: this.array_options.options_vendredi_matin_fin,
				daysOfWeek: [5]
			});
		}
		if (this.array_options?.options_vendredi_am_debut && this.array_options?.options_vendredi_am_fin) {
			workingHours.push({
				startTime: this.array_options.options_vendredi_am_debut,
				endTime: this.array_options.options_vendredi_am_fin,
				daysOfWeek: [5]
			});
		}
		return workingHours.length > 0 ? workingHours : null;
	}

	getAllPoles() {
		const poles = [...this.pole_m];
		poles.push(this.pole_id);
		return poles;
	}
}
